export default __webpack_public_path__ + "static/media/searchNewIcon.242a8da3.svg";